import React, { useState } from "react";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { FileSpreadsheet, FileText, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadRitiriExcel, downloadRinnoviPdf } from "../lib/api_extra";

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}

const today = new Date();
const defaultMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;

export default function Esportazioni() {
  const [month, setMonth] = useState(defaultMonth);
  const [soglia, setSoglia] = useState(120);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);

  const onExcel = async () => {
    setLoadingExcel(true);
    try {
      const blob = await downloadRitiriExcel({ period: "month", month });
      downloadBlob(blob, `ritiri_olioesausto_${month}.xlsx`);
      toast.success("Excel scaricato");
    } catch (ex) { toast.error("Errore export Excel"); }
    finally { setLoadingExcel(false); }
  };

  const onPdf = async () => {
    setLoadingPdf(true);
    try {
      const blob = await downloadRinnoviPdf(soglia);
      downloadBlob(blob, `rinnovi_contratti_${today.toISOString().slice(0, 10)}.pdf`);
      toast.success("PDF scaricato");
    } catch (ex) { toast.error("Errore export PDF"); }
    finally { setLoadingPdf(false); }
  };

  return (
    <div className="space-y-4" data-testid="esportazioni-page">
      <div>
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Esportazioni</h1>
        <p className="text-slate-500 text-sm mt-1">Excel mensile ritiri · PDF rinnovi contratti</p>
      </div>

      <Card className="p-5 border-slate-200">
        <div className="flex items-center gap-2 mb-3">
          <FileSpreadsheet size={20} className="text-[#1B5E20]" />
          <h2 className="text-base font-semibold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
            Report ritiri mensile (Excel)
          </h2>
        </div>
        <p className="text-xs text-slate-500 mb-3">
          Foglio con: data, cliente, zona, mezzo, operatore, kg, prezzo €/kg, importo, note. Totali in fondo.
        </p>
        <div className="flex gap-2 items-end">
          <div className="flex-1 max-w-[200px]">
            <Label className="text-xs">Mese (YYYY-MM)</Label>
            <Input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="excel-month" className="h-11" />
          </div>
          <Button onClick={onExcel} disabled={loadingExcel} className="bg-[#1B5E20] hover:bg-[#144818] text-white min-h-[44px]" data-testid="excel-download">
            {loadingExcel ? <Loader2 size={16} className="animate-spin" /> : <><Download size={16} className="mr-1" /> Scarica</>}
          </Button>
        </div>
      </Card>

      <Card className="p-5 border-slate-200">
        <div className="flex items-center gap-2 mb-3">
          <FileText size={20} className="text-[#F57C00]" />
          <h2 className="text-base font-semibold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
            Report rinnovi contratti (PDF)
          </h2>
        </div>
        <p className="text-xs text-slate-500 mb-3">
          Una pagina per cliente con scadenza entro la soglia, dati contratto + andamento ultimi 12 mesi.
        </p>
        <div className="flex gap-2 items-end">
          <div className="flex-1 max-w-[200px]">
            <Label className="text-xs">Soglia (giorni alla scadenza)</Label>
            <Input type="number" value={soglia} onChange={(e) => setSoglia(Number(e.target.value))} data-testid="pdf-soglia" className="h-11" />
          </div>
          <Button onClick={onPdf} disabled={loadingPdf} className="bg-[#F57C00] hover:bg-[#E65100] text-white min-h-[44px]" data-testid="pdf-download">
            {loadingPdf ? <Loader2 size={16} className="animate-spin" /> : <><Download size={16} className="mr-1" /> Scarica</>}
          </Button>
        </div>
      </Card>
    </div>
  );
}
